/**
 * Microsoft Word 아이콘 SVG
 *
 * 크기 조절: className으로 w-*, h-* 클래스 사용
 * @example
 * ```tsx
 * <MicrosoftWordIcon className="w-8 h-8" />
 * <MicrosoftWordIcon className="w-12 h-12" />
 * ```
 */
export function MicrosoftWordIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      aria-label="Microsoft Word icon"
      role="img"
    >
      <title>Microsoft Word</title>
      <g id="Microsoft Powerword">
        <g id="Vector">
          <path
            d="M18.5354 2.5V5.01161C21.9353 5.03036 25.6552 4.97706 29.056 5.03036C29.176 5.00977 29.2992 5.01708 29.4157 5.05169C29.5323 5.08631 29.6391 5.14729 29.7277 5.22977C29.8162 5.31226 29.884 5.41399 29.9257 5.52687C29.9675 5.63976 29.9819 5.76069 29.968 5.88006C30.022 12.0638 29.955 18.6009 30 24.7857C29.98 25.1804 30.009 25.889 29.947 26.2828C29.868 26.7851 29.641 26.8818 29.13 26.9499C28.844 26.9884 28.3661 26.9835 28.0851 26.9963C25.2932 26.9825 22.5033 26.9854 19.7114 26.9864H18.5364V29.5L2 26.9844C2 19.6598 2 12.3372 2 5.01654L18.5354 2.5Z"
            fill="#283C82"
          />
          <path
            d="M18.5354 5.95308H29.0351V26.0439H18.5354V23.5323H26.8051V22.277H18.5354V20.7079H26.8051V19.4516H18.5354V17.8825H26.8051V16.6262H18.5354V15.057H26.8051V13.8007H18.5354V12.2316H26.8051V10.9753H18.5354V9.40617H26.8051V8.14987H18.5354V5.95308Z"
            fill="white"
          />
          <path
            d="M8.57173 11.5004C9.17171 11.4658 9.78068 11.4411 10.3847 11.4096C10.8076 13.5284 11.2406 15.6443 11.6986 17.7542C12.0576 15.5752 12.4556 13.4031 12.8406 11.228C13.4766 11.2063 14.1125 11.1717 14.7455 11.1293C14.0265 14.1709 13.3966 17.2381 12.6116 20.2619C12.0806 20.5352 11.2856 20.249 10.6557 20.2934C10.2327 18.2151 9.73969 16.1486 9.3607 14.0623C8.98871 16.0962 8.50473 18.1026 8.07874 20.1178C7.4681 20.0862 6.85512 20.0497 6.23981 20.0082C5.71183 17.245 5.09185 14.5024 4.59887 11.7333C5.14285 11.7086 5.68983 11.6859 6.23381 11.6671C6.5618 13.6666 6.93379 15.6571 7.21978 17.6595C7.66776 15.6068 8.12674 13.5531 8.57173 11.5004Z"
            fill="white"
          />
        </g>
      </g>
    </svg>
  );
}
